import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden pb-[0.1em] -mb-[0.1em] ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "115%", rotate: 2.5 }}
      animate={{ y: "0%", rotate: 0 }}
      transition={{ duration: 1.15, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.95, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono text-[11px] tracking-[0.28em] uppercase text-eucalyptus">
    {children}
  </p>
);

export default Reveal;
